import { PropsWithChildren, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { LinearProgress, Typography, Dialog, DialogContent, DialogContentText, DialogTitle, Box } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

import QrHandler from 'components/QrHandler';

type DescriptionProps = {
	title: string | ReactNode;
	description: string | ReactNode;
	confirmButton?: string;
	cancelButton?: string;
	hideCancel?: boolean;
	onClose: (code?: string) => void;
	loading?: boolean;
	loadingTitle?: string;
	warningMessage?: string | ReactNode;
	children?: any;
};

type ChildrenProps = PropsWithChildren<Omit<DescriptionProps, 'description'> & { description?: string }>;

export type QrScanModalBasePropsType = DescriptionProps | ChildrenProps;

export default function AdminConfirmationDialog(props: QrScanModalBasePropsType) {
	const { t } = useTranslation();

	return (
		<Dialog
			open={true}
			disableEscapeKeyDown={true}
			aria-labelledby={''}
			aria-describedby={''}
			maxWidth="md"
			fullWidth
			PaperProps={{
				sx: {
					minHeight: '80vh',
					maxHeight: '90vh',
				},
			}}
		>
			{!!props.loading && <LinearProgress />}
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					mr: 2,
					cursor: 'pointer',
				}}
			>
				<DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
				<CloseIcon onClick={() => props.onClose()} />
			</Box>
			<DialogContent
				sx={{
					position: 'relative',
					overflow: 'hidden',
					p: 0,
					display: 'flex',
					flexDirection: 'column',
					height: '100%',
				}}
			>
				<div style={{ padding: '16px' }}>
					<DialogContentText id="alert-dialog-description">{props.description}</DialogContentText>

					{props.warningMessage && (
						<Typography variant="body1" sx={{ mt: 1, color: 'warning.main' }}>
							{props.warningMessage}
						</Typography>
					)}

					{!!props.loading && (
						<DialogContentText id="alert-dialog-description">{t('common:loading')}</DialogContentText>
					)}
				</div>

				<div style={{ flex: 1, position: 'relative', minHeight: '500px' }}>
					<QrHandler onClose={props.onClose} onScan={props.onClose} />
				</div>
			</DialogContent>
		</Dialog>
	);
}
